var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.tsx
export * from "@telescope/cassini-core";
import {
  extendTheme,
  withDefaultColorScheme,
  withDefaultSize,
  withDefaultVariant,
  theme,
  mergeThemeOverride,
  withDefaultProps
} from "@chakra-ui/react";
export * from "@chakra-ui/theme";
export * from "@chakra-ui/css-reset";
export * from "@chakra-ui/media-query";
export * from "@chakra-ui/focus-lock";
export * from "@chakra-ui/system";

// src/cassini-provider/CassiniProvider.tsx
import { ChakraProvider } from "@chakra-ui/provider";
import { theme as baseChakraTheme } from "@chakra-ui/theme";
import { ToastProvider } from "@chakra-ui/toast";
import { jsx, jsxs } from "react/jsx-runtime";
function CassiniProvider(_a) {
  var _b = _a, { children, toastOptions } = _b, restProps = __objRest(_b, ["children", "toastOptions"]);
  return /* @__PURE__ */ jsxs(ChakraProvider, __spreadProps(__spreadValues({}, restProps), {
    children: [
      children,
      /* @__PURE__ */ jsx(ToastProvider, __spreadValues({}, toastOptions))
    ]
  }));
}
CassiniProvider.defaultProps = {
  theme: baseChakraTheme
};
export {
  CassiniProvider,
  extendTheme,
  mergeThemeOverride,
  theme,
  withDefaultColorScheme,
  withDefaultProps,
  withDefaultSize,
  withDefaultVariant
};
